import { useEffect, useState } from "react";
import Hero from "../components/Hero";
import MarqueeBanner from "../components/MarqueeBanner";
import Activities from "../components/Activities";
import WorshipSection from "../components/WorshipSection";
import Speaker from "../components/Speaker";
import FamiliaSection from "../components/FamiliaSection";
import SponsorSection from "../components/SponsorSection";
import InviteFriendsSection from "../components/InviteFriendsSection";
import RegistrationForm from "../components/RegistrationForm";
import Footer from "../components/Footer";
import LiveActivityFeed from "../components/LiveActivityFeed";
import MyAccountLookup from "../components/MyAccountLookup";
import MyAccountFAB from "../components/MyAccountFAB";
import BackgroundMusic from "../components/BackgroundMusic";

export default function Landing() {
  const [lookupOpen, setLookupOpen] = useState(false);

  const scrollToRegister = () => {
    document.getElementById("inscripcion")?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    document.title = "Operación Rescate · Campamento de Jóvenes 2026";
  }, []);

  return (
    <div className="min-h-screen">
      <Hero onRegister={scrollToRegister} onOpenLookup={() => setLookupOpen(true)} />
      <MarqueeBanner />
      <Activities />
      <WorshipSection />
      <Speaker />
      <FamiliaSection />
      <SponsorSection />
      <InviteFriendsSection />
      <RegistrationForm />
      <Footer />
      <LiveActivityFeed />
      <MyAccountLookup open={lookupOpen} onClose={() => setLookupOpen(false)} />
      <BackgroundMusic />
      <MyAccountFAB />
    </div>
  );
}
